import React from "react";

const SearchBox2 = ({ value, onChange, onKeyPress }) => {
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      onChange({ currentTarget: { value: "" } });
    }
  };

  const handleClear = () => {
    onChange({ currentTarget: { value: "" } });
  };

  return (
    <div className="search-field my-3">
      <i className="fa fa-search search-icon" aria-hidden="true" />
      <input
        type="search"
        name="query"
        placeholder="Search..."
        value={value}
        onChange={e => onChange(e)}
        onKeyPress={e => (onKeyPress ? onKeyPress(e) : null)}
        onKeyDown={handleKeyDown}
      />
      {value ? (
        <button
          type="button"
          className="search-clear"
          onClick={handleClear}
          aria-label="Clear search"
        >
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
};

export default SearchBox2;



// WEBPACK FOOTER //
// ./src/components/searchBox2.jsx